/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterM = createReactComponent("outline", "letter-m", "IconLetterM", [["path", { "d": "M6 20v-16l6 14l6 -14v16", "key": "svg-0" }]]);

export { IconLetterM as default };
//# sourceMappingURL=IconLetterM.mjs.map
